import { Coding } from "@medplum/fhirtypes";

import { LOINCCodes } from "@/fhir/enums/loinc";
import { Systems } from "@/fhir/enums/systems";

export const LMP_CODING: Coding = {
  system: Systems.LOINC,
  code: LOINCCodes.LastMenstrualPeriodStartDate,
  display: "Last Menstrual Period Start Date",
} as const;

export const LMP_CODING_QUERY = `${LMP_CODING.system}|${LMP_CODING.code}`;

export const LMP_RELIABILITY_CODING: Coding = {
  system: Systems.LOINC,
  code: LOINCCodes.LMPReliability,
  display: "Last Menstrual Period Reliability",
} as const;

export const LMP_RELIABILITY_CODING_QUERY = `${LMP_RELIABILITY_CODING.system}|${LMP_RELIABILITY_CODING.code}`;
